import styled from "styled-components";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { H3 } from "@/common/elements";
import { BsDot } from "react-icons/bs";
import { Button } from "@/common/components/button";
import { BiEdit } from "react-icons/bi";
import { FiDelete } from "react-icons/fi";
import { CiSettings } from "react-icons/ci";

const AddressCards = styled.div`
  width: 100%;
  padding: 1rem;
  background-color: ${({ theme }) => theme.bg.prim_500};
  margin-bottom: 1rem;

  .address-wrapper {
    display: flex;
    align-items: start;
    gap: 1rem;

    .icon-wrapper {
      background-color: ${({ theme }) => theme.bg.prim_400};
      padding: 0.5rem;
    }

    .default {
      background-color: ${({ theme }) => theme.bg.secondary};
      color: ${({ theme }) => theme.text.prim_500};
      border-radius: 4rem;
      padding: 0.1rem 0.5rem;
      display: flex;
      align-items: center;
    }

    .default svg {
      color: ${({ theme }) => theme.bg.prim_500};
      width: 2rem;
      height: 2rem;
    }
  }
`;

interface IAddressCardProps {
  id: string;
  building_number: string;
  street: string;
  city: string;
  state: string;
  lga: string;
  country: string;
  landmark: string;
  isDefault?: boolean;
}

const AddressCard = ({
  index,
  address,
}: {
  index: number;
  address: IAddressCardProps;
}) => {
  return (
    <AddressCards>
      <div className="address-wrapper">
        <div className="icon-wrapper">
          <HiOutlineBuildingOffice2 size={30} />
        </div>
        <div className="address-details">
          <div className="flex items-center gap-4 mb-4">
            <H3>Address {index}</H3>
            {address?.isDefault && (
              <span className="default">
                <BsDot /> Default
              </span>
            )}
          </div>
          <p>
            {address?.building_number} {address?.street}, {address?.city},{" "}
          </p>
          <p>{address?.state}</p>
          <p>{address?.country}</p>
          <p>{address?.landmark}</p>
        </div>
      </div>
      <div className="flex items-center gap-4 mt-4 justify-end">
        <Button secondary>
          <BiEdit /> Edit
        </Button>
        <Button>
          <FiDelete /> Delete
        </Button>
        {!address?.isDefault && (
          <Button>
            <CiSettings /> Set as Default
          </Button>
        )}
      </div>
    </AddressCards>
  );
};

export default AddressCard;
